import { render, staticRenderFns } from "./ServiceBuilder.vue?vue&type=template&id=48c4bce6&scoped=true"
import script from "./ServiceBuilder.vue?vue&type=script&lang=js"
export * from "./ServiceBuilder.vue?vue&type=script&lang=js"
import style0 from "./ServiceBuilder.vue?vue&type=style&index=0&id=48c4bce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c4bce6",
  null
  
)

export default component.exports